// extracted by mini-css-extract-plugin
export default {"footer":"PageFooter_footer__VD8+8","wrapper":"PageFooter_wrapper__y2eQ9"};